export interface NameMatch {
  before: string;
  match: string;
  after: string;
}

const WORD_SEPARATORS = /[\s:,\-–]+/;

export function matchesDestinationName(name: string, query: string): boolean {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery === '') {
    return false;
  }
  const lower = name.toLowerCase();
  if (lower.startsWith(normalizedQuery)) {
    return true;
  }
  return lower.split(WORD_SEPARATORS).some((word) => word.startsWith(normalizedQuery));
}

export function splitDestinationName(name: string, query: string): NameMatch | null {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery === '') {
    return null;
  }
  const index = name.toLowerCase().indexOf(normalizedQuery);
  if (index < 0) {
    return null;
  }
  return {
    before: name.slice(0, index),
    match: name.slice(index, index + normalizedQuery.length),
    after: name.slice(index + normalizedQuery.length),
  };
}
